export default "__VITE_PUBLIC_ASSET__180daa8d__"